import { render, staticRenderFns } from "./DeParaContasCaixa.vue?vue&type=template&id=25ab4f5f"
import script from "./DeParaContasCaixa.vue?vue&type=script&lang=ts"
export * from "./DeParaContasCaixa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports